import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import NotebookWorkLog from './components/NotebookWorkLog';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import UseCaseQuiz from './components/UseCaseQuiz';
import Integrations from './components/Integrations';
import AIDisclaimer from './components/AIDisclaimer';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-[#F7F5F2] text-[#1A1A18] selection:bg-[#EBF2F9] selection:text-[#1E4D7A]">
      <Navbar />
      <main>
        <Hero />
        <NotebookWorkLog />
        <HowItWorks />
        <Features />
        <UseCaseQuiz />
        <Integrations />
        <AIDisclaimer />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;